/* Remote images are blocked in some preview sandboxes. Label the gap
   instead of leaving a hole, so the layout still reads correctly. */
window.wireImages = function(){
  document.querySelectorAll('img:not([data-wired])').forEach(function(img){
    img.setAttribute('data-wired','1');
    img.addEventListener('error', function(){
      // First failure: retry on the shop domain before giving up.
      var fb = img.getAttribute('data-fallback');
      if (fb && !img.dataset.retried) { img.dataset.retried = '1'; img.src = fb; return; }
      var box = img.closest('.card-media,.idx-img,.hero-img,.prov-img,.video,.occ,figure');
      if (!box) return;
      box.classList.add('imgfail');
      if (!box.hasAttribute('data-label')) {
        box.setAttribute('data-label', img.getAttribute('alt') || 'Product photo');
      }
    });
    if (img.complete && img.naturalWidth === 0) img.dispatchEvent(new Event('error'));
  });
};
window.wireImages();